import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import SalesRoutes from './Components/Routes/SalesRoutes';
import ProductionRoutes from './Components/Routes/ProductionRoutes';
import { decryptUserInfo } from './Components/SharedFiles/decryption/Decryption';
import LoginPage from './Components/LoginPage/LoginPage';
import { logout } from './Components/APIServices/Login/loginSlice';
import Order from './Components/Pages/SalesApp/Orders/Order';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '../src/Components/SharedFiles/CommonFile/Style.css';
import 'primeicons/primeicons.css';
import { QRModalProvider } from './Context/QrContext';
import ProtectedRoute from './Components/Hooks/useAuth';
import RedirectIfLoggedIn from './Components/Hooks/RedirectIfLoggedIn';
import UnauthorizedPage from './Components/Pages/Unauthorized/UnauthorizedPage';

const App = () => {
  const dispatch = useDispatch();
  const { user, isAuthenticated } = useSelector((state) => state.login); // Get authentication state from Redux
  const [userData, setUserData] = useState([]); // Local state for user data
  const userActive = sessionStorage.getItem("userData");

  // useEffect(() => {
  //   const storedUserData = sessionStorage.getItem("user");
  //   if (storedUserData) {
  //     const userParse = JSON.parse(storedUserData);
  //     const decryptedUser = decryptUserInfo(userParse);
  //     setUserData(decryptedUser);
  //   } else if (user) {
  //     const decryptedUser = decryptUserInfo(user);
  //     setUserData(decryptedUser);
  //   } else {
  //     setUserData([]);
  //   }
  // }, [user,isAuthenticated]);

  useEffect(() => {
    const storedUserData = sessionStorage.getItem("user");
    let decryptedUser = [];
    if (storedUserData) {
      const userParse = JSON.parse(storedUserData);
      decryptedUser = decryptUserInfo(userParse);
    } else if (user) {
      decryptedUser = decryptUserInfo(user);
    }
  
    // Only update state if decryptedUser changed meaningfully
    setUserData((prevUserData) => {
      // You can do a deep compare or stringify for simplicity
      if (JSON.stringify(prevUserData) !== JSON.stringify(decryptedUser)) {
        return decryptedUser;
      }
      return prevUserData;
    });
  }, [user, isAuthenticated]);
  
  return (
    <Router>
      <div>
        <Routes>
          
          <Route
            path="/login"
            element={
              <RedirectIfLoggedIn userData={userData}>
                <LoginPage />
              </RedirectIfLoggedIn>
            }
          />

          <Route path="/" element={<Navigate to="/login" replace />} />

          <Route
            path="/unauthorized"
            element={
              <RedirectIfLoggedIn userData={userData}>
                <UnauthorizedPage />
              </RedirectIfLoggedIn>
            }
          />

          {/* <Route path="*" element={<Navigate to="/login" replace />} /> */}
          {/* <Route path="/login" element={<LoginPage />} /> */}

          <Route element={<ProtectedRoute allowedRoles={['S1', 'C1']} />}>
            <Route path="/sales/*" element={<SalesRoutes />} />
          </Route>
          <Route element={<ProtectedRoute allowedRoles={["P1"]} />}>
            <Route path="/production/*" element={<QRModalProvider> <ProductionRoutes /> </QRModalProvider>} />
          </Route>

        </Routes>
      </div>
    </Router>
  );
};

export default App;







// import React, { useEffect, useState } from 'react';
// import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
// import LoginPage from './Components/LoginPage/LoginPage';
// // import store from './Components/ReduxStore/store'
// import store from './Components/APIServices/store';
// import { Provider } from 'react-redux';
// import { useDispatch, useSelector } from 'react-redux';
// import Dashboard from './Components/Dashboard/Dashboard';
// // import GrpoDetails from './Components/GRPO/Grpo';
// import GRPOMain from './Components/GRPOViews/GRPOMain';
// import ITMain from './Components/InventoryTransferViews/ITMain';
// import PaymentCollection from './Components/PaymentCollection/PaymentCollection';
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// import InvPostingMain from './Components/InventoryPosting/inventoryPosting';
// import DeliveryMain from './Components/Deliveryscreen/deliveryMain';
// import DisassembleMain from './Components/DisassembleViews/DisassembleMain';
// import ProductionFgMain from './Components/ProductionFG/ProductionFgMain';
// import QRScannerWithPrint from './Components/QRScannerwithprint/QRScannerWithPrint';
// import QRScannerWithPrintTest from './Components/QRScannerwithprint/QRScannerWithPrintTest ';
// import TestQr from './Components/QRScannerwithprint/TestQr';
// import SalesRoutes from './Components/Routes/SalesRoutes';
// import ProductionRoutes from './Components/Routes/ProductionRoutes';
// import { logout } from './Components/APIServices/Login/loginSlice';
// import { decryptUserInfo } from './Components/SharedFiles/decryption/Decryption';

// function App() {
//   return (
//     <>
//       {/* provide the database name */}
//       <Provider store={store}>

//         <Router>
//           <Routes>
//             <Route path="/" element={<LoginPage />} />
//             <Route path="/Dashboard" element={<Dashboard />} />
//             {/* <Route path="/Grpo" element={<GrpoDetails/>} /> */}
//             <Route path="/GRPOMain" element={<GRPOMain />} />
//             <Route path="/ITMain" element={<ITMain />} />
//             <Route path="/PaymentCollection" element={<PaymentCollection />} />
//             <Route path="/InventoryPosting" element={<InvPostingMain />} />
//             <Route path="/Delivery" element={<DeliveryMain />} />
//             <Route path="/Disassemble" element={<DisassembleMain />} />
//             <Route path="/ProductionFg" element={<ProductionFgMain />} />
//             <Route path="/TestQr" element={<TestQr/>} />
//             <Route path="/QRScannerWithPrint" element={<QRScannerWithPrint />} />
//             <Route path="/QRScannerWithPrintTest" element={<QRScannerWithPrintTest />} />
//           </Routes>
//         </Router>
//       </Provider>
//     </>
//   );
// }

// export default App;
